import axios from '@/services'

export default {
  guestLogin: async () => await axios.get('/api/user/guest/login'),
  emailLogin: async (payload) => await axios.post('/api/user/login', payload),
  getAccessToken: async (config) => await axios.post('/apiuaepass/token', {}, config),
  getUAEPassUserInfo: async (config) => await axios.get('/apiuaepass/userinfo', config),
  getProfile: async () => await axios.get('/api/userProfile/current'),

  // registration endpoints
  registerUser: async (type, payload) =>
    axios.post(`/api/user/registration/type/${type}/email/verification`, payload),
  getIndividualInfo: async () => await axios.get('/api/individual/info'),
  getEstablishmentInfo: async (payload = {}) => await axios.get('/api/establishment/info', payload),

  changePassword: async (body) => await axios.post('/api/user/changePassword', body),
  changeUsername: async (body) => await axios.post('/api/user/IndividualChangeUsername', body),
  deactivateAccount: async (body) => await axios.get('/api/userProfile/deactivateAccount', body)
}
